import {
  isPartOfDateRangeField,
  areMatchingDateTimeFields,
  getDateRangeFieldsGroupedByModelMap,
  getFieldIdAndLabel,
  isDateRangeField,
  toCombinedDateRangeFieldName,
  toCombinedDateRangeFieldIds,
  isComponentOfDateRangeField,
  replaceEmptyDates,
  replaceEmptyDateRangePartFieldValue,
  fieldIsPartOfDateRangeField,
  isDateRangeValue,
} from './utils';
import {
  mergeDateRangeFieldsForEntity,
  getMergedDateRangeFieldForScopeData,
  mergeDateRangeFieldsForDiffContext,
  mergeDateRangeFieldsOnMetamodel,
  mergeDateTimeFieldsToDateRangeFields,
  mergeGlobalFieldsToDateRangeFields,
  foo,
  mergeDateRangeFieldLabels,
  mergeDateRangeFieldNames,
  mergeDateRangeFieldNamesWithLabelValidation,
  mergeDateRangeFieldsByFieldPairs,
} from './mergeUtils';
import {
  fieldNameIsPartOfDateRangeField,
  fieldNameIsDateRangeEndField,
  isCombinedDateRangeFieldNames,
  fieldNameIsDateRangeStartField,
  toStartDateName,
  toEndDateName,
  extractDateRangeFieldName,
  createCombinedDateRangeFieldNames,
  getDateRangeDateTimeFieldCounterpartName,
  getDateRangeFieldNamePairsFromFieldNames,
  getDefinedEmptyDateRangeFieldValueString,
  maybeExpandDateRangeFieldName,
  maybeGetCombinedDateRangeFieldName,
  normalizeDateRangeFieldNames,
} from './nameUtils';
import {
  extractDateRangeFieldLabel,
  toStartDateLabel,
  toEndDateLabel,
  fieldLabelIsDateRangeStartField,
  fieldLabelIsDateRangeEndField,
  compareDateRangeFieldLabels,
  dashFormatDateRangeFieldLabel,
  fieldLabelIsPartOfDateRangeField,
} from './labelUtils';
import {
  splitFieldsOnEntity,
  splitDateRangeFieldIntoStartAndEndSelectOptions,
} from './splitUtils';

export type { DateRangeFieldAttributes, DateRangeFieldValues } from './types';

export {
  getDateRangeType,
  getDateRangePartType,
  isDateRangeFieldType,
} from './utils';

export { getStartDateName, getEndDateName, toStartDateName } from './nameUtils';

export { pairDateRangeFields } from './mergeUtils';

export * from './consts';

export const dateRangeOperations = {
  isPartOfDateRangeField,
  areMatchingDateTimeFields,
  mergeDateRangeFieldsForEntity,
  getMergedDateRangeFieldForScopeData,
  mergeDateRangeFieldsForDiffContext,
  mergeDateTimeFieldsToDateRangeFields,
  fieldNameIsPartOfDateRangeField,
  fieldIsPartOfDateRangeField,
  fieldNameIsDateRangeEndField,
  isCombinedDateRangeFieldNames,
  fieldNameIsDateRangeStartField,
  toStartDateName,
  toEndDateName,
  extractDateRangeFieldName,
  getDateRangeDateTimeFieldCounterpartName,
  getDateRangeFieldNamePairsFromFieldNames,
  replaceEmptyDates,
  replaceEmptyDateRangePartFieldValue,
  createCombinedDateRangeFieldNames,
  extractDateRangeFieldLabel,
  toStartDateLabel,
  toEndDateLabel,
  fieldLabelIsDateRangeStartField,
  fieldLabelIsDateRangeEndField,
  fieldLabelIsPartOfDateRangeField,
  compareDateRangeFieldLabels,
  dashFormatDateRangeFieldLabel,
  splitFieldsOnEntity,
  getDateRangeFieldsGroupedByModelMap,
  splitDateRangeFieldIntoStartAndEndSelectOptions,
  mergeDateRangeFieldsOnMetamodel,
  getFieldIdAndLabel,
  isDateRangeField,
  toCombinedDateRangeFieldName,
  toCombinedDateRangeFieldIds,
  isComponentOfDateRangeField,
  getDefinedEmptyDateRangeFieldValueString,
  mergeGlobalFieldsToDateRangeFields,
  foo,
  mergeDateRangeFieldLabels,
  mergeDateRangeFieldNames,
  mergeDateRangeFieldNamesWithLabelValidation,
  mergeDateRangeFieldsByFieldPairs,
  maybeExpandDateRangeFieldName,
  maybeGetCombinedDateRangeFieldName,
  normalizeDateRangeFieldNames,
  isDateRangeValue,
};
